import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentStore } from "../store/environment.store";

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor(
    private environmentStore: EnvironmentStore
  ) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.headers.has('X-Skip-Interceptor')) {
      const headers = request.headers.delete('X-Skip-Interceptor');
      const requestClone = request.clone({ headers });
      return next.handle(requestClone);
    }

    const requestClone = request.clone({
      url: `${this.environmentStore.api}/${request.url}`
    });

    return next.handle(requestClone);
  }
}
